export default __webpack_public_path__ + "static/media/long_play_button.2c6b86de.png";